import { text } from './terms.js';
import { 
    PolicyContainer, 
    Policy, 
    PolicyTitle, 
    PolicyText 
} from '../PolicyElements';


const TermsOfUse = () => {
    return (
        <PolicyContainer>
            <Policy>
                <PolicyTitle>Terms of use</PolicyTitle>
                <PolicyText>{text}</PolicyText>
            </Policy>
        </PolicyContainer>
    );
}

export default TermsOfUse